import { HeaderComp } from 'ag-grid-community/dist/lib/headerRendering/header/headerComp';

const HeaderHTMLRenderer = class extends HeaderComp {
    init(params) {
        super.init(params);

        let headerValue = params.displayName.trim();
        let resizeColumns = false;
        if (headerValue.includes('As of')) {
            headerValue = headerValue.replace(
                /(as of)(.*)/gi,
                '<div class="sub-label">$1$2</div>'
            );
            resizeColumns = true;
        }
        this.eGui.querySelector('[ref="eText"]').innerHTML = `${headerValue}`;

        if (resizeColumns) {
            params.api.sizeColumnsToFit();
        }
    }
};

export default HeaderHTMLRenderer;
